export default __webpack_public_path__ + "static/media/27.1 burger-logo.png.ec69c7f6.png";